if (typeof VatToggle !== 'function') {
	class VatToggle extends HTMLElement {
		constructor() {
			super()

			this.toggle = this.querySelector('input')
			if (!sessionStorage.getItem('vat')) sessionStorage.setItem('vat', 'incVat')

			window.addEventListener('load', () => this.handleUpdates())

			const customEvents = [
				'addToCart',
				'facetsRender',
				'cartUpdated',
				'updateCartQty',
				'recommendationsRendered',
				'VARIANT_CHANGE',
				'mwBundlesLoaded',
				'modalOpen',
				'wgAfterCart'
			]
			customEvents.forEach(event => {
				document.addEventListener(event, () => this.handleUpdates())
			})

			this.toggle.addEventListener('change', () => this.onToggle())
		}

		onToggle() {
			const newVatValue = sessionStorage.getItem('vat') === 'exVat' ? 'incVat' : 'exVat'
			sessionStorage.setItem('vat', newVatValue)
			this.handleUpdates()
		}

		handleUpdates() {
			this.updatePrices()
			this.updateToggleEls()
			this.updateBoxDopplePrice()
		}

		updatePrices() {
			const bundlePrices = document.querySelector('mw-bundle-product')?.shadowRoot.querySelectorAll('[data-price]') || []
			const pagePrices = document.querySelectorAll('[data-price]') || []
			const prices = [...bundlePrices, ...pagePrices]
			prices.forEach(price => {
				const priceValue = price.dataset.variantPrice ?? price.dataset.price
				const exVatPrice = Number(priceValue / 100).toFixed(2)
				const vatPrice = Number(priceValue * 1.2 / 100).toFixed(2)
				const currencySymbol = window.theme.cart.currencySymbol
				const exVatText = window.theme.cart.exVatText
				const incVatText = window.theme.cart.incVatText
				const pricePreText = price.innerHTML.split(currencySymbol)[0]

				const priceString = sessionStorage.getItem('vat') === 'exVat'
					? `${pricePreText && pricePreText} ${currencySymbol}${exVatPrice}`
					: `${pricePreText && pricePreText} ${currencySymbol}${vatPrice}`

				// Update price HTML using priceString value if priceValue is defined and not 0, otherwise remove price
				if(priceValue && parseInt(priceValue) !== 0) {
					price.innerHTML = priceString

					// Append inc/ex VAT message if not disabled
					if(price.dataset.vatLabel != 'false') {
						if(sessionStorage.getItem('vat') === 'exVat') {
							price.innerHTML = `${price.innerHTML} <span class="vat-text">${exVatText}</span>`
						}
						else {
							price.innerHTML = `${price.innerHTML} <span class="vat-text">${incVatText}</span>`
						}
					}
				}
				else {
					price.innerHTML = `<span class="vat-text"></span>`
				}
			})

			document.dispatchEvent(new Event('vatToggleInitialised'))
		}

		updateToggleEls() {
			const vatToggleEls = document.querySelectorAll('vat-toggle')
			vatToggleEls.forEach(vatToggleEl => {
				sessionStorage.getItem('vat') === 'exVat'
					? vatToggleEl.querySelector('input').setAttribute('checked', 'checked')
					: vatToggleEl.querySelector('input').removeAttribute('checked')
			})
		}

		updateBoxDopplePrice() {
			// Siva from AppInbox

			let boxProductPrice = null

			// If product is bundle
			const bundleWidget = document.querySelector('mw-bundle-product')
			if(!bundleWidget) {
				return
			}

			const bundlePrice = bundleWidget.shadowRoot.querySelector('.TotalPrice')
			if(bundlePrice) {
				// Get discount price if present
				const discountBundlePrice = bundleWidget.shadowRoot.querySelector('.TotalPriceDiscounted')
				if(discountBundlePrice) {
					boxProductPrice = this.parsePrice(discountBundlePrice.firstChild.nodeValue)
				}
				// Otherwise use regular bundle price
				else {
					boxProductPrice = this.parsePrice(bundlePrice.firstChild.nodeValue)
				}
			}
			// Non-bundle product
			else {
				// Normal Product
				let standardProductPrice = document.getElementsByClassName("product-price--original")[0];
				let standardProductPriceString = standardProductPrice.textContent
				let standardProductPriceResult = standardProductPriceString.replace(/[^0-9.]/g, "");
				boxProductPrice = standardProductPriceResult.substring(0, standardProductPriceResult.length - 1);
			}

			if(!boxProductPrice || isNaN(boxProductPrice) || boxProductPrice == 0) {
				return
			}

			let iframeCalc = document.getElementById("appinbox-iframe-calc")
			iframeCalc.src = "https://app.dopplepay.com/api/merchants/v1/information/product-finance-calculator/9cddfb4f-732d-44e4-840c-949671f6d3cf?value=" + boxProductPrice

			let jsonContainer = document.getElementById("json-data-container")

			// 1-500  OR 1000-infinite
			if (boxProductPrice <  50 || boxProductPrice > 3000) {
				jsonContainer.style.display = 'none'
			}
			else {
				jsonContainer.style.display = 'block'
			}
		}

        parsePrice(price) {
			return Number(price.replace(/[^0-9\.-]+/g, '')).toFixed(2)
		}
	}

	if (typeof customElements.get('vat-toggle') == 'undefined') {
		customElements.define('vat-toggle', VatToggle)
	}
}
